import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'supportTicketMessageAuthor',
  standalone: false,
})
export class SupportTicketMessageAuthorPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | null | undefined): string {
    if (value === null || value === '' || value === undefined) {
      return '';
    }
    const key = `enums.supportTicketMessageAuthor.${value}`;
    const out = this.translate.instant(key) as string;
    if (out !== key) {
      return out;
    }
    return value;
  }
}
